export default "__VITE_ASSET__$9IuikuD__"